/* global window */

import AiOutlineClose from '../icons/AiOutlineClose';
import AppContext from './context/AppContext';
import { array, bool, object } from 'prop-types';
import Cart from './Cart';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavigationDropdownMenu from './NavigationDropdownMenu';
import NavigationMobile from './NavigationMobile';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import RxHamburgerMenu from '../icons/RxHamburgerMenu';
import SearchBox from './SearchBox';
import '../styles/Navigation.css';
import protectCopyRight from '../helpers/protectCopyRight';
import { Link } from 'react-router-dom';
import ContactUsHeader from './ContactUsHeader';
import { IoHome } from 'react-icons/io5';
import { CustomerContext } from './context/CustomerContext';
import { FaUser } from 'react-icons/fa';
import { IoIosMore } from 'react-icons/io';

const COMMON_CLASS_NAMES = 'd-flex flex-column';

const Navigation = ({ navData, isMobile, searchBoxRef }) => {
    const { customerData } = useContext(CustomerContext);
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;
    const navbarRef = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const [searchLoaded, setSearchLoaded] = useState(false);
    const [productList, setProductList] = useState([]);
    const [searchQuery, setSearchQuery] = useState({
        q: '',
        v: '',
        sortBy: '',
        limit: appConfig.defaultLimitPerPage,
        page: 0,
        minPrice: '',
        maxPrice: '',
        t: [],
        c: [],
    });
    const userLoggedIn = useMemo(() => customerData && Object.keys(customerData).length > 0, [customerData]);

    useEffect(() => {
        const detectOutsideClick = (e) => {
            if (navbarRef.current !== null && expanded === true
                && !navbarRef.current.contains(e.target)) {
                setExpanded(false);
            }
            if (
                navbarRef.current !== null && expanded === true
                && navbarRef.current.contains(e.target)
                && e.target.tagName === 'A' && !e.target.classList.contains('dropdown-toggle')
            ) {
                setExpanded(false);
            }
        };
        window.addEventListener('click', detectOutsideClick, true);
        return () => {
            window.removeEventListener('click', detectOutsideClick, true);
        };
    }, [expanded]);

    const collapse = useCallback(() => setExpanded(false), []);
    const expand = useCallback(() => setExpanded(true), []);
    const toggleExpanded = useCallback(() => setExpanded(!expanded), [expanded]);

    const handleAuthClick = useCallback(() => {
        if (userLoggedIn) {
            window.location.assign('/logout');
        } else {
            window.location.assign('/login');
        }
    }, [userLoggedIn]);

    return (<Navbar
        variant={'light'}
        expand={isMobile === false ? 'lg' : false}
        className={`navbar__ab ${(expanded && !isMobile) ? 'desktop-expanded' : ''}`}
        expanded={expanded}>
        <Container
            className={'nav-first-level'}>
            <div
                className={'navigation--toggle-and-brand'}>
                <div
                    className={'d-flex'}>
                    <div
                        className={'navigation--toggle'}>
                        <Navbar.Toggle
                            aria-controls={'basic-navbar-nav'}>
                            {expanded === false && (<RxHamburgerMenu
                                size={'35px'}
                                onClick={expand} />)}
                            {expanded === true && (<AiOutlineClose
                                size={'35px'}
                                onClick={collapse} />)}
                        </Navbar.Toggle>
                        <NavigationMobile
                            navData={navData}
                            ref={navbarRef} />
                    </div>
                    <Navbar.Brand
                        as={Link}
                        to={'/'}>
                        <img
                            onContextMenu={protectCopyRight}
                            src={appContext.config.storeLogoUrl}
                            className={'d-inline-block align-top nav-logo'}
                            style={{
                                transition: '0.4s width ease-in-out',
                                objectFit: 'contain',
                            }}
                            width={188}
                            height={56}
                            alt={appContext.config.storeName}
                        />
                    </Navbar.Brand>
                </div>
            </div>
            <div
                className={'navigation--search-and-cart'}>
                <SearchBox
                    isMobile={isMobile}
                    searchLoaded={searchLoaded}
                    setSearchLoaded={setSearchLoaded}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    productList={productList}
                    ref={searchBoxRef}
                    setProductList={setProductList} />
                <div
                    className={'desktop-only'}>
                    <ContactUsHeader />
                </div>
                {!isMobile && <Cart
                    isMobile={isMobile}/> }
            </div>
        </Container>
        <Container
            className={'nav-second-level'}>
            <Nav
                className={'navigation--menu'}>
                {navData.map((navLink) => <NavigationDropdownMenu
                    key={navLink.id}
                    navLink={navLink} />)}
            </Nav>
        </Container>
        <div
            className={'mobile-only w-100 navigation--mobile-bottom-bar'}>
            <div
                className={'d-flex justify-content-around'}>
                <Link
                    className={COMMON_CLASS_NAMES}
                    to={'/'}>
                    <IoHome
                        size={24} />
                    <span>
                        Home
                    </span>
                </Link>
                <Cart
                    isMobile={isMobile} />
                <Link
                    className={COMMON_CLASS_NAMES}
                    to={'#'}
                    onClick={handleAuthClick}>
                    <FaUser
                        size={24} />
                    <span>
                        {userLoggedIn ? 'Sign Out' : 'Sign In'}
                    </span>
                </Link>
                <Link
                    to={'#'}
                    onClick={toggleExpanded}
                    className={COMMON_CLASS_NAMES}>
                    {expanded === false && (<IoIosMore
                        size={24} />)}
                    {expanded === true && (<AiOutlineClose
                        size={24}/>)}
                    <span>More</span>
                </Link>
            </div>
        </div>
        <div
            className={'mobile-only px-2 w-100 pt-3'}
            style={{
                backgroundColor: '#fff'
            }}>
            <ContactUsHeader
                useExpandedForm={true} />
        </div>
    </Navbar>);
};

Navigation.propTypes = {
    navData: array,
    isMobile: bool,
    searchBoxRef: object,
};

export default Navigation;